//#region src/sanitizeUrl.ts
/**
* The code is taken from the `@braintree/sanitize-url` library
*/
const invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
const htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
const htmlCtrlEntityRegex = /&(newline|tab);/gi;
const ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
const urlSchemeRegex = /^.+(:|&colon;)/gim;
const whitespaceEscapeCharsRegex = /(\\|%5[cC])((%(6[eE]|72|74))|[nrt])/g;
const relativeFirstCharacters = [".", "/"];
const isRelativeUrlWithoutProtocol = (url) => {
	return relativeFirstCharacters.indexOf(url[0]) > -1;
};
const decodeHtmlCharacters = (str) => {
	const removedNullByte = str.replace(ctrlCharactersRegex, "");
	return removedNullByte.replace(htmlEntitiesRegex, (_, dec) => {
		return String.fromCharCode(dec);
	});
};
const isValidUrl = (url) => {
	try {
		const _urlCheck = new URL(url);
		return true;
	} catch {
		return false;
	}
};
const decodeURI = (uri) => {
	try {
		return decodeURIComponent(uri);
	} catch (e) {
		return uri;
	}
};
const sanitizeUrl = (url) => {
	let charsToDecode;
	let decodedUrl = decodeURI(url.trim());
	let decodeIterationCount = 0;
	do {
		decodedUrl = decodeHtmlCharacters(decodedUrl).replace(htmlCtrlEntityRegex, "").replace(ctrlCharactersRegex, "").replace(whitespaceEscapeCharsRegex, "").trim();
		decodedUrl = decodeURI(decodedUrl);
		charsToDecode = decodedUrl.match(ctrlCharactersRegex) || decodedUrl.match(htmlEntitiesRegex) || decodedUrl.match(htmlCtrlEntityRegex) || decodedUrl.match(whitespaceEscapeCharsRegex);
		decodeIterationCount++;
	} while (charsToDecode && charsToDecode.length > 0 && decodeIterationCount < 100);
	const sanitizedUrl = decodedUrl;
	if (!sanitizedUrl) throw new Error("Invalid URL: sanitization process resulted in an empty or invalid URL");
	if (isRelativeUrlWithoutProtocol(sanitizedUrl)) return sanitizedUrl;
	const trimmedUrl = sanitizedUrl.trimStart();
	const urlSchemeParseResults = trimmedUrl.match(urlSchemeRegex);
	if (!urlSchemeParseResults) return sanitizedUrl;
	const urlScheme = urlSchemeParseResults[0].toLowerCase().trim();
	if (invalidProtocolRegex.test(urlScheme)) throw new Error(`Invalid URL: dangerous protocol - ${urlScheme}`);
	const backSanitized = trimmedUrl.replace(/\\/g, "/");
	if (urlScheme === "mailto:" || urlScheme.includes("://")) return backSanitized;
	if (urlScheme === "http:" || urlScheme === "https:") {
		if (!isValidUrl(backSanitized)) throw new Error(`Invalid URL: Failed to parse url witn "new URL()" constructor - ${backSanitized}`);
		const url$1 = new URL(backSanitized);
		url$1.protocol = url$1.protocol.toLowerCase();
		url$1.hostname = url$1.hostname.toLowerCase();
		return url$1.toString();
	}
	return backSanitized;
};

//#endregion
export { sanitizeUrl };
//# sourceMappingURL=index.mjs.map